import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Slider } from "@mui/material";
import axios from "axios";
import swal from "sweetalert";
import PageHeading from "../../Components/PageHeading/PageHeading";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import sampleIcon from "../../Assets/Images/info.png";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import AiFactsDisplay from "../../Components/AiFacts/AiFactsDisplay";
// import "./VideoAiCopy.css";
import "./VideoAi.css";
import SamplePdfModal from "../../Components/SamplePdfModal/SamplePdfModal";
import ContentVideoAi from "../Gallery/ContentVideoAi";
import { saveAs } from "file-saver";
import { DownloadOutlined } from "@mui/icons-material";
import InfoIcon from '@mui/icons-material/Info';
import { VideoAiExamplePrompt } from "./VideoAiExamplePrompt";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ImageIcon from "@mui/icons-material/Image";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import BoltIcon from "@mui/icons-material/Bolt";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import FavoriteIcon from "@mui/icons-material/Favorite";
import StarIcon from "@mui/icons-material/Star";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DownloadIcon from "@mui/icons-material/Download";
import PRO_TIPS from "./proTips";
import MovieIcon from "@mui/icons-material/Movie";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TuneIcon from "@mui/icons-material/Tune";
import AiFilmmakingInsightsDisplay from "../../Components/AiFacts/AiFilmmakingInsightsDisplay";

const MODES = [
    {
        key: "Text to Video (T2V)",
        label: "T2V", icon: <EditNoteIcon />,
        desc: "Text to Video (T2V): Create a video from a text prompt",
        title: "Text to Video (T2V): Create a video from a text prompt"
    },
    {
        key: "Image to Video (I2V)",
        label: "I2V", icon: <ImageIcon />,
        desc: "Image to Video (I2V): Animate a single uploaded image.",
        title: "Image to Video (I2V): Animate a single uploaded image"
    },
    {
        key: "Frame Interpolation",
        label: "Frames", icon: <SwapHorizIcon />,
        desc: "Frame Interpolation: Upload both a start frame and an end frame to generate a smooth transition.",
        title: "Frame Interpolation: Upload both a start frame and an end frame to generate a smooth transition."
    }
];

const PACKAGE_RATES = {
    package1: 0.02,
    package2: 0.016,
    package3: 0.012,
};

const MODELS = [
    { value: "veo-3.1", label: "Veo 3.1", tag: "Best Quality", desc: "Supports 4s, 6s, 8s", info: "High-fidelity, cinematic generation optimized for high visual realism and precise prompt adherence in standard short clips.", allowImg: 3, timeInfo: "Approximately 5 seconds of processing time is needed to generate 1 second of video." },
    { value: "kling", label: "Kling V3.0 Pro", tag: "High Quality", desc: "Supports 3s to 15s", info: "Professional-grade video generation optimized for longer, complex motion sequences up to 15 seconds.", allowImg: 1, timeInfo: "Approximately 19.73 seconds of processing time is needed to generate 1 second of video." },
    { value: "veo-3.1-lite", label: "Veo 3.1 Lite", tag: "Fast & Affordable", desc: "Supports 4s, 6s, 8s", info: "A balanced, resource-efficient option that delivers high quality visual output while consuming fewer processing credits.", allowImg: 0, timeInfo: "Approximately 8.75 seconds of processing time is needed to generate 1 second of video." },
    { value: "seedance", label: "Seedance 2.5", tag: "Balanced", desc: "Supports 4s to 30s", info: "Highly flexible motion generation suited for fluid action, multi-frame continuity, and extended clip lengths up to 30 seconds.", allowImg: 1, timeInfo: "Approximately 33.5 seconds of processing time is needed to generate 1 second of video." },
    { value: "veo-3.1-fast", label: "Veo 3.1 Fast", tag: "Ultra Fast", desc: "Supports 4s, 6s, 8s", info: "Optimized for rapid rendering speed, offering quick concept iteration and rapid previews without compromising core composition.", allowImg: 3, timeInfo: "Approximately 17.5 seconds of processing time is needed to generate 1 second of video." },
    { value: "wan-2.7", label: "Wan 2.7", tag: "Cost Effective", desc: "Supports 2s to 10s", info: "Quick-burst generation ideal for short, highly dynamic motion snippets and precise timing adjustments up to 10 seconds.", allowImg: 1, timeInfo: "Approximately 10.75 seconds of processing time is needed to generate 1 second of video." },
    { value: "wan-3.0", label: "Wan 3.0", tag: "Experimental", desc: "Supports 2s to 30s", info: "Advanced temporal continuity model designed for extended, seamless video generation lasting up to 30 seconds.", allowImg: 1, timeInfo: "Approximately 26.88 seconds of processing time is needed to generate 1 second of video." },
    { value: "omni-flash", label: "Omni Flash", tag: "Fast & Affordable", desc: "Supports 4s, 6s, 8s", info: "A fast and affordable option for generating high-quality videos with quick turnaround times.", allowImg: 2, timeInfo: "Approximately 3.7 seconds of processing time is needed to generate 1 second of video." }
];

const ASPECTS = [
    { value: "16:9", label: "Widescreen", icon: "🖥️" },
    { value: "9:16", label: "Vertical", icon: "📱" }
];

const RESOLUTIONS = [
    { value: "480p", label: "480p", icon: "SD" },
    { value: "720p", label: "720p", icon: "HD" },
    { value: "1080p", label: "1080p", icon: "FHD" },
    { value: "2K", label: "2K", icon: "2K" },
    { value: "4K", label: "4K", icon: "4K" }
];

const MODEL_RESOLUTIONS = {
    "wan-2.7": ["720p", "1080p"],
    "wan-3.0": ["480p", "720p", "1080p"],
    "kling": ["720p"],
    "seedance": ["480p", "1080p", "2k", "4K"],
    "veo-3.1": ["720p", "1080p", "4K"],
    "veo-3.1-fast": ["720p", "1080p", "4K"],
    "veo-3.1-lite": ["720p", "1080p"],
    "omni-flash": ["720p", "1080p", "4K"]
};

const CREDIT_RATE_MAP = {
    "veo-3.1-lite": {
        "720p": 10,
        "1080p": 14
    },

    "kling": {
        "720p": 28,
        "1080p": 48
    },

    "veo-3.1-fast": {
        "720p": 18,
        "1080p": 20,
        "4K": 50
    },

    "veo-3.1": {
        "720p": 68,
        "1080p": 68,
        "4K": 100
    },

    "seedance": {
        "480p": 12,
        "720p": 26,
        "1080p": 64,
        "4K": 130
    },

    "wan-2.7": {
        "720p": 24,
        "1080p": 48
    },

    "wan-3.0": {
        "480p": 12,
        "720p": 24,
        "1080p": 48
    },
    "omni-flash": {
        "720p": 24,
        "1080p": 48,
        "4K": 100
    },
};

const VIDEO_SHOWCASE_DATA = [
    {
        id: 1,
        title: "FAITH IS STRONGEST WHEN TESTED",
        type: "Image to Video",
        videoUrl:
            "https://backend.whalesai.com/public/hiwvideos/video-ai-sample-6.mp4",
        poster: "/videoaic6.PNG",
    },
    {
        id: 2,
        title: "THE LAST ELEPHANT",
        type: "Image to Video",
        videoUrl:
            "https://backend.whalesai.com/public/hiwvideos/video-ai-sample-2.mp4",
        poster: "/videoaic2.jpeg",
    },
    {
        id: 3,
        title: "NEPAL FLASH FLOOD 2026",
        type: "Text to Video",
        videoUrl:
            "https://backend.whalesai.com/public/hiwvideos/video-ai-sample.mp4",
        poster: "/videoaic1.jpeg",
    },
    {
        id: 4,
        title: "HANUMAN: THE JOURNEY TO LANKA",
        type: "Image to Video",
        videoUrl:
            "https://backend.whalesai.com/public/hiwvideos/video-ai-sample-5.mp4",
        poster: "/videoaic3.PNG",
    },
    {
        id: 5,
        title: "FAITH OPENS THE IMPOSSIBLE PATH",
        type: "Image to Video",
        videoUrl:
            "https://backend.whalesai.com/public/hiwvideos/video-ai-sample-7.mp4",
        poster: "/videoaic7.PNG",
    },
    {
        id: 5,
        title: "FROM IDEA TO MOVIE IN 60 SECONDS",
        type: "Image to Video",
        videoUrl:
            "https://backend.whalesai.com/public/hiwvideos/video-ai-sample-8.mp4",
        poster: "/videoaic8.PNG",
    },
    {
        id: 6,
        title: "KRISHNA'S VISHVARUPA",
        type: "Image to Video",
        videoUrl:
            "https://backend.whalesai.com/public/hiwvideos/video-ai-sample-9.mp4",
        poster: "/videoaic9.jpeg",
    }
];

const SpecialEmail = [
    "wealthpluz@gmail.com",
    "Findexxclub@gmail.com",
    "Findexxapp@gmail.com",
    "Psanandakrishna@gmail.com",
    "findexxclub@gmail.com",
    "findexxkossh@gmail.com",
    "Findexxkosh2023@gmail.com",
    // "turzacse@gmail.com",
    "priya@dsl.sg"
]

export default function VideoAiCopy() {
    const [mode, setMode] = useState(MODES[0].key);
    const [prompt, setPrompt] = useState("");
    const [textRenderingEnabled, setTextRenderingEnabled] = useState(false);
    const [textRendering, setTextRendering] = useState("");
    const [modelType, setModelType] = useState("");
    const [duration, setDuration] = useState("");
    const [aspectRatio, setAspectRatio] = useState("");
    const [resolution, setResolution] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [generatedVideo, setGeneratedVideo] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [suggestedPrompt, setSuggestedPrompt] = useState("");
    const [promptSuggestion, setPromptSuggestion] = useState("");
    const [isCheckingPrompt, setIsCheckingPrompt] = useState(false);
    const [currentTipIndex, setCurrentTipIndex] = useState(() =>
        Math.floor(Math.random() * PRO_TIPS.length)
    );
    const currentTip = PRO_TIPS[currentTipIndex];
    const [recommendationData, setRecommendationData] = useState(null);
    const [startImage, setStartImage] = useState(null);
    const [startPreview, setStartPreview] = useState(null);
    const [endImage, setEndImage] = useState(null);
    const [i2vImages, setI2vImages] = useState([]);
    const [i2vPreviews, setI2vPreviews] = useState([]);
    const [endPreview, setEndPreview] = useState(null);
    const [audioFile, setAudioFile] = useState(null);
    const [audioName, setAudioName] = useState("");
    const [isRecommandLoading, setIsRecommandLoading] = useState(false);
    const [selectedModelInfo, setSelectedModelInfo] = useState(null);
    const [selectedModel, setSelectedModel] = useState();
    const [storyboardZoom, setStoryboardZoom] = useState(1);

    const startRef = useRef(null);
    const endRef = useRef(null);
    const audioRef = useRef(null);
    const videoRefs = useRef([]);
    const generatorRef = useRef(null);
    const viewRef = useRef(null);
    const { AIuser, userRefetch, setUserRefetch } = useContext(UserAuthContext);
    const navigate = useNavigate();

    const userEmail = AIuser?.email?.trim().toLowerCase();

    const isSpecialUser = SpecialEmail.some(
        (email) => email.toLowerCase() === userEmail
    );

    const SPECIAL_MODELS = [
        "veo-3.1",
        "veo-3.1-lite",
        "veo-3.1-fast",
    ];

    const isModelAllowed = (modelValue) => {
        if (isSpecialUser) {
            return SPECIAL_MODELS.includes(modelValue);
        }

        // return !SPECIAL_MODELS.includes(modelValue);
        return true; // Allow all models for non-special users
    };

    const creditToLocalString = AIuser?.credits ? parseInt(Math.floor(AIuser?.credits)).toLocaleString() : "0";

    const totalCredits = duration && modelType && resolution
        ? Math.round((CREDIT_RATE_MAP[modelType]?.[resolution] || 0) * Number(duration) * 1)
        : 0;
    const creditCostUSD = totalCredits * 0.012;
    const creditCostUSD1 = totalCredits * 0.02;
    const creditCostUSD2 = totalCredits * 0.016;

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {
        setSuggestedPrompt(VideoAiExamplePrompt[Math.floor(Math.random() * VideoAiExamplePrompt.length)]);

        const intervalId = setInterval(() => {
            setSuggestedPrompt(VideoAiExamplePrompt[Math.floor(Math.random() * VideoAiExamplePrompt.length)]);
        }, 10000);

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        let pollingTimer = null;
        let isChecking = false;

        const markVideoViewed = async (transactionId) => {
            if (!transactionId) return;

            try {
                await fetch(
                    "https://backend.whalesai.com/api/v1/video-ai/mark-viewed",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: `Bearer ${localStorage.getItem("aiUser")}`,
                        },
                        body: JSON.stringify({ transactionId }),
                    }
                );
            } catch (error) {
                console.error("Error marking video viewed:", error);
            }
        };

        const clearTransaction = (transactionId) => {
            const activeStr = localStorage.getItem("active_video_ai");

            if (!activeStr) return;

            try {
                const active = JSON.parse(activeStr);

                if (
                    !transactionId ||
                    active.transactionId === transactionId
                ) {
                    localStorage.removeItem("active_video_ai");
                }
            } catch (error) {
                localStorage.removeItem("active_video_ai");
            }
        };

        const handleCompletedVideo = async (videoData) => {
            if (!videoData?.videoUrl) return;

            const transactionId = videoData.transactionId;

            setGeneratedVideo({
                ...videoData,
                status: "completed",
            });

            setIsLoading(false);

            clearTransaction(transactionId);

            localStorage.removeItem("unviewed_video_ai");

            // Refresh credits/user data
            setUserRefetch((prev) => !prev);

            // Mark viewed without blocking UI
            markVideoViewed(transactionId);
        };

        const handleFailedVideo = (data) => {
            setIsLoading(false);

            clearTransaction(data?.transactionId);

            swal({
                text:
                    data?.message ||
                    "AI Video generation failed.",
                icon: "error",
                buttons: "Ok",
                className: "modal_class_success",
            });
        };

        const checkActiveVideo = async () => {
            if (isChecking) return;

            const activeStr =
                localStorage.getItem("active_video_ai");

            if (!activeStr) {
                return;
            }

            let stored;

            try {
                stored = JSON.parse(activeStr);
            } catch (error) {
                localStorage.removeItem("active_video_ai");
                return;
            }

            if (!stored?.transactionId) {
                localStorage.removeItem("active_video_ai");
                return;
            }

            isChecking = true;

            try {
                const response = await fetch(
                    "https://backend.whalesai.com/api/v1/video-ai/active-status",
                    {
                        method: "GET",
                        headers: {
                            authorization: `Bearer ${localStorage.getItem(
                                "aiUser"
                            )}`,
                        },
                        cache: "no-store",
                    }
                );

                if (!response.ok) {
                    throw new Error(
                        `Active status request failed: ${response.status}`
                    );
                }

                const result = await response.json();

                console.log(
                    "[Video AI] Active status:",
                    result
                );

                // Make sure this response belongs to our generation
                if (
                    result?.transactionId &&
                    result.transactionId !== stored.transactionId
                ) {
                    return;
                }

                // ==============================
                // GENERATING
                // ==============================

                if (
                    result?.success &&
                    result?.isGenerating
                ) {
                    setIsLoading(true);
                    return;
                }

                // ==============================
                // COMPLETED
                // ==============================

                if (
                    result?.success &&
                    result?.status === "completed" &&
                    result?.data?.videoUrl
                ) {
                    await handleCompletedVideo({
                        status: "completed",
                        transactionId:
                            result.transactionId ||
                            stored.transactionId,
                        videoUrl: result.data.videoUrl,
                        data: result.data,
                    });

                    return;
                }

                // ==============================
                // FAILED
                // ==============================

                if (
                    result?.success &&
                    (
                        result?.status === "failed" ||
                        result?.status === "error"
                    )
                ) {
                    handleFailedVideo({
                        transactionId:
                            result.transactionId ||
                            stored.transactionId,
                        message:
                            result.message ||
                            "AI Video generation failed.",
                    });

                    return;
                }

                // IMPORTANT:
                // Don't remove active_video_ai merely because
                // isGenerating is false.
            } catch (error) {
                console.error(
                    "[Video AI] Active status error:",
                    error
                );
            } finally {
                isChecking = false;
            }
        };

        // =====================================================
        // CHECK UNVIEWED VIDEO FIRST
        // =====================================================

        const checkUnviewedVideo = async () => {
            const unviewedStr =
                localStorage.getItem("unviewed_video_ai");

            if (!unviewedStr) {
                return false;
            }

            try {
                const unviewed = JSON.parse(unviewedStr);

                if (
                    Array.isArray(unviewed) &&
                    unviewed.length > 0
                ) {
                    const videoData =
                        unviewed[unviewed.length - 1];

                    if (videoData?.videoUrl) {
                        await handleCompletedVideo(videoData);
                        return true;
                    }
                }
            } catch (error) {
                console.error(
                    "Error parsing unviewed video:",
                    error
                );
            }

            return false;
        };

        // =====================================================
        // INITIAL CHECK
        // =====================================================

        const initializeVideoStatus = async () => {
            const hasUnviewed =
                await checkUnviewedVideo();

            if (!hasUnviewed) {
                await checkActiveVideo();
            }
        };

        initializeVideoStatus();

        // =====================================================
        // POLLING
        // =====================================================

        pollingTimer = setInterval(() => {
            checkActiveVideo();
        }, 3000);

        // =====================================================
        // BACKEND EVENT
        // =====================================================

        const handleBackendTask = (e) => {
            const data = e.detail;

            console.log(
                "[Video AI] Backend completion event:",
                data
            );

            if (
                data?.type === "video_ai_completed" &&
                data?.status === "completed" &&
                data?.videoUrl
            ) {
                handleCompletedVideo(data);
            }
        };

        const handleBackendTaskFailed = (e) => {
            const data = e.detail;

            console.log(
                "[Video AI] Backend failed event:",
                data
            );

            if (
                data?.type === "video_ai_failed" &&
                data?.status === "failed"
            ) {
                handleFailedVideo(data);
            }
        };

        window.addEventListener(
            "backend_task_completed",
            handleBackendTask
        );

        window.addEventListener(
            "backend_task_failed",
            handleBackendTaskFailed
        );

        // =====================================================
        // TAB / BROWSER WAKE UP
        // =====================================================

        const handleWakeUp = () => {
            if (
                document.visibilityState === "visible" ||
                !document.hidden
            ) {
                checkUnviewedVideo();
                checkActiveVideo();
            }
        };

        document.addEventListener(
            "visibilitychange",
            handleWakeUp
        );

        window.addEventListener(
            "focus",
            handleWakeUp
        );

        window.addEventListener(
            "pageshow",
            handleWakeUp
        );

        // =====================================================
        // CLEANUP
        // =====================================================

        return () => {
            if (pollingTimer) {
                clearInterval(pollingTimer);
            }

            window.removeEventListener(
                "backend_task_completed",
                handleBackendTask
            );

            window.removeEventListener(
                "backend_task_failed",
                handleBackendTaskFailed
            );

            document.removeEventListener(
                "visibilitychange",
                handleWakeUp
            );

            window.removeEventListener(
                "focus",
                handleWakeUp
            );

            window.removeEventListener(
                "pageshow",
                handleWakeUp
            );
        };
    }, []);
    //combined 2 effects from 274 to 450

    useEffect(() => {
        if (!prompt.trim()) {
            setPromptSuggestion("");
            setIsCheckingPrompt(false);
            return;
        }

        const timer = setTimeout(() => {
            checkPromptSuggestion(prompt);
        }, 600);

        return () => clearTimeout(timer);
    }, [prompt]);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTipIndex((currentIndex) => {
                let nextIndex;

                do {
                    nextIndex = Math.floor(Math.random() * PRO_TIPS.length);
                } while (
                    PRO_TIPS.length > 1 &&
                    nextIndex === currentIndex
                );

                return nextIndex;
            });
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const getModelPerSecondCost = (modelValue) => {
        const rates = CREDIT_RATE_MAP[modelValue];

        if (!rates) {
            return {
                package1: 0,
                package2: 0,
                package3: 0,
            };
        }

        // First available resolution for the model
        const resolutionRate = Object.values(rates)[0] || 0;

        return {
            package1: resolutionRate * PACKAGE_RATES.package1,
            package2: resolutionRate * PACKAGE_RATES.package2,
            package3: resolutionRate * PACKAGE_RATES.package3,
        };
    };

    const checkPromptSuggestion = async (currentPrompt) => {
        const trimmedPrompt = currentPrompt.trim();

        if (!trimmedPrompt) {
            setPromptSuggestion("");
            setIsCheckingPrompt(false);
            return;
        }

        setIsCheckingPrompt(true);

        try {
            const response = await fetch(
                "https://backend.whalesai.com/api/v1/prompt-checker/check",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${localStorage.getItem("aiUser")}`,
                    },
                    body: JSON.stringify({
                        prompt: trimmedPrompt,
                        aiService: "video-ai",
                        targetModel: modelType
                    }),
                }
            );

            const result = await response.json();
            console.log("Suggested Prompt:", result)

            console.log("Prompt suggestion result:", result);

            if (!response.ok || !result.success) {
                throw new Error(
                    result.message || "Failed to generate prompt suggestion"
                );
            }

            const suggestion =
                result.suggested_prompt ||
                result.data?.suggested_prompt ||
                "";

            setPromptSuggestion(suggestion);
        } catch (error) {
            console.error("Prompt suggestion error:", error);
            setPromptSuggestion("");
        } finally {
            setIsCheckingPrompt(false);
        }
    };

    const handleFileChange = (e, setFile, setPreview, isImage = true) => {
        const file = e.target.files[0];
        if (!file) return;
        setFile(file);
        if (isImage) {
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(file);
        } else {
            setAudioName(file.name);
        }
    };

    const handleI2VImagesChange = (e) => {
        const files = Array.from(e.target.files || []);
        if (!files.length) return;
        const maxImages = getI2VMaxImages(modelType);
        const remainingSlots = maxImages - i2vImages.length;
        if (remainingSlots <= 0) {
            swal({
                text: `You can upload a maximum of ${maxImages} image${maxImages > 1 ? "s" : ""} for ${formatModelName(modelType)}.`,
                icon: "warning",
                buttons: "Ok",
                className: "modal_class_success",
            });
            e.target.value = "";
            return;
        }
        const selectedFiles = files.slice(0, remainingSlots);
        if (files.length > remainingSlots) {
            swal({
                text: `You can upload a maximum of ${maxImages} image${maxImages > 1 ? "s" : ""} for ${formatModelName(modelType)}. Only ${remainingSlots} image${remainingSlots > 1 ? "s" : ""} added.`,
                icon: "warning",
                buttons: "Ok",
                className: "modal_class_success",
            });
        }
        const newImages = [...i2vImages, ...selectedFiles];
        setI2vImages(newImages);
        if (
            (modelType === "veo-3.1" || modelType === "veo-3.1-fast") &&
            newImages.length > 1
        ) {
            setDuration("8");
        }
        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setI2vPreviews((prev) => [...prev, reader.result]);
            };
            reader.readAsDataURL(file);
        });
        e.target.value = "";
    };

    const handleRemoveFile = (e, setFile, setPreview, ref) => {
        e.stopPropagation();
        setFile(null);
        if (setPreview) setPreview(null);
        if (ref?.current) ref.current.value = "";
    };

    const handleStoryboardZoomIn = () => {
        setStoryboardZoom((prev) =>
            Math.min(prev + 0.2, 3)
        );
    };

    const handleStoryboardZoomOut = () => {
        setStoryboardZoom((prev) =>
            Math.max(prev - 0.2, 0.6)
        );
    };

    const handleStoryboardZoomReset = () => {
        setStoryboardZoom(1);
    };

    const handleStoryboardDownload = () => {
        try {
            const imageUrl =
                recommendationData?.data?.storyboard?.imageUrl;

            if (!imageUrl) {
                swal({
                    icon: "error",
                    title: "Download failed",
                    text:
                        "Storyboard image is not available.",
                    className: "modal_class_success",
                });

                return;
            }

            const filename =
                imageUrl.split("/").pop();

            if (!filename) {
                throw new Error(
                    "Invalid storyboard image URL."
                );
            }

            const downloadUrl =
                `https://backend.whalesai.com/api/v1/recommendation/storyboards/${encodeURIComponent(
                    filename
                )}/download`;

            const link =
                document.createElement("a");

            link.href = downloadUrl;

            document.body.appendChild(link);

            link.click();

            link.remove();

        } catch (error) {

            console.error(
                "Storyboard download failed:",
                error
            );

            swal({
                icon: "error",
                title: "Download failed",
                text:
                    "Unable to download the storyboard image.",
                className: "modal_class_success",
            });
        }
    };

    const handleRemoveI2VImage = (index, e) => {
        e.stopPropagation();

        const updatedImages = i2vImages.filter((_, i) => i !== index);

        setI2vImages(updatedImages);

        setI2vPreviews((prev) => prev.filter((_, i) => i !== index));

        if (
            (modelType === "veo-3.1" || modelType === "veo-3.1-fast") &&
            updatedImages.length > 1
        ) {
            setDuration("8");
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e, setFile, setPreview, isImage = true) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            handleFileChange({ target: { files: e.dataTransfer.files } }, setFile, setPreview, isImage);
        }
    };

    const formatModelName = (model) => {
        if (!model) return "—";

        return model
            .split("-")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    const handleGenerate = async () => {
        if (AIuser.credits < totalCredits) {
            swal({
                text: "You don't have enough credits! Please buy credits to continue.",
                icon: "error",
                buttons: "Buy",
                className: "modal_class_success",
            }).then((v) => {
                if (v) navigate("/purchase");
            });

            return;
        }

        if (!prompt.trim()) {
            swal({
                text: "Please enter a prompt.",
                icon: "warning",
                buttons: "Ok",
                className: "modal_class_success",
            });
            return;
        }

        if (!modelType) {
            swal({
                text: "Please select a model.",
                icon: "warning",
                buttons: "Ok",
                className: "modal_class_success",
            });
            return;
        }

        if (!duration) {
            swal({
                text: "Please select a duration.",
                icon: "warning",
                buttons: "Ok",
                className: "modal_class_success",
            });
            return;
        }

        if (!resolution) {
            swal({
                text: "Please select a resolution.",
                icon: "warning",
                buttons: "Ok",
                className: "modal_class_success",
            });
            return;
        }

        if (!aspectRatio) {
            swal({
                text: "Please select an aspect ratio.",
                icon: "warning",
                buttons: "Ok",
                className: "modal_class_success",
            });
            return;
        }

        if (mode === "Image to Video (I2V)") {
            const maxImages = getI2VMaxImages(modelType);

            if (i2vImages.length > maxImages) {
                swal({
                    text: `${formatModelName(modelType)} supports a maximum of ${maxImages} image${maxImages > 1 ? "s" : ""}.`,
                    icon: "warning",
                    buttons: "Ok",
                    className: "modal_class_success",
                });

                return;
            }
        }

        if (mode === "Frame Interpolation" && (!startImage || !endImage)) {
            swal({
                text: "Please upload both start and end frames.",
                icon: "warning",
                buttons: "Ok",
                className: "modal_class_success",
            });
            return;
        }

        if (mode === "Audio-Driven (S2V)" && !audioFile) {
            swal({
                text: "Please upload an audio file.",
                icon: "warning",
                buttons: "Ok",
                className: "modal_class_success",
            });
            return;
        }

        // =========================
        // FINAL GENERATION CONFIRMATION
        // =========================

        const confirmed = await swal({
            title: "Ready to Generate?",

            content: {
                element: "div",
                attributes: {
                    innerHTML: `
                <div class="va-swal-cost-info">
                    <div>Model: ${formatModelName(modelType)}</div>
                    <div>Duration: ${duration}s</div>
                    <div>Resolution: ${resolution}</div>
                    <div>Aspect Ratio: ${aspectRatio}</div>

                    <div class="va-swal-total-cost">
                        Estimated Cost: ${totalCredits} Credits
                    </div>

                    <div class="va-swal-package package-1">
                        Package 1: USD ${creditCostUSD1.toFixed(2)}
                    </div>

                    <div class="va-swal-package package-2">
                        Package 2: USD ${creditCostUSD.toFixed(2)}
                    </div>

                    <div class="va-swal-package package-3">
                        Package 3: USD ${creditCostUSD.toFixed(2)}
                    </div>

                    <div class="va-swal-continue">
                        Do you want to continue?
                    </div>
                </div>
            `,
                },
            },

            icon: "info",

            buttons: {
                cancel: {
                    text: "Cancel",
                    visible: true,
                    className: "va-swal-cancel-btn",
                },

                confirm: {
                    text: "Generate Video",
                    className: "va-swal-generate-btn",
                },
            },

            className: "va-generate-confirm-modal",
        });

        if (!confirmed) return;

        // User clicked Cancel / closed the modal
        if (!confirmed) {
            return;
        }

        setIsLoading(true);

        try {
            const formData = new FormData();

            formData.append("credit", totalCredits);
            formData.append("mode", mode);
            formData.append("prompt", prompt.trim());
            formData.append(
                "textRendering",
                textRenderingEnabled ? textRendering : ""
            );
            formData.append("model", modelType);
            formData.append("duration", duration);
            formData.append("resolution", resolution);
            formData.append("aspectRatio", aspectRatio);

            // if (mode === "Image to Video (I2V)") {
            //     formData.append("startImage", startImage);
            // }
            if (mode === "Image to Video (I2V)") {
                i2vImages.forEach((image) => {
                    formData.append("startImage", image);
                });
            }

            if (mode === "Frame Interpolation") {
                formData.append("startFrame", startImage);
                formData.append("endFrame", endImage);
            }

            if (audioFile) {
                formData.append("audio", audioFile);
            }

            console.log("Sending data===>>>", formData);

            const response = await fetch(
                "https://backend.whalesai.com/api/v1/video-ai/generate",
                {
                    method: "POST",
                    headers: {
                        authorization: `Bearer ${localStorage.getItem("aiUser")}`,
                    },
                    body: formData,
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(
                    result.message || "Failed to generate video"
                );
            }

            setUserRefetch(!userRefetch);

            // const txId =
            //     result.transactionId ||
            //     result.data?.transactionId;

            // if (txId) {
            //     localStorage.setItem(
            //         "active_video_ai",
            //         JSON.stringify({
            //             transactionId: txId,
            //             aiType: "video-ai",
            //         })
            //     );
            // }

            const txId =
                result?.transactionId ||
                result?.data?.transactionId;

            if (!txId) {
                throw new Error(
                    "Video generation started but no transaction ID was returned."
                );
            }
            localStorage.setItem(
                "active_video_ai",
                JSON.stringify({
                    transactionId: txId,
                    aiType: "video-ai",
                    startedAt: Date.now(),
                })
            );
        } catch (error) {
            console.error("Error generating video:", error);

            setIsLoading(false);

            swal({
                text:
                    error.message ||
                    "Something went wrong! Please try again.",
                icon: "error",
                buttons: "Ok",
                className: "modal_class_success",
            });
        }
    };

    const handleConvertResolution = async (targetResolution) => {
        console.log("Convert video to:", targetResolution);
        // coming soon! swal 
        // swal({ 
        // TODO:
        // Call your video conversion API here
    };

    const downloadVideo = async () => {
        const urlToDownload = typeof generatedVideo === 'string' ? generatedVideo : generatedVideo?.videoUrl;
        if (!urlToDownload) return;
        setDownloading(true);
        try {
            const response = await fetch(urlToDownload);
            if (!response.ok) throw new Error("Network response was not ok");
            const blob = await response.blob();

            // Extract filename from URL
            const pathname = new URL(urlToDownload).pathname;
            const filename = pathname.split("/").pop() || "GeneratedVideo.mp4";
            saveAs(blob, filename);
        } catch (error) {
            console.error("Download failed:", error);
            swal({
                text: "Failed to download the video.",
                icon: "error",
                buttons: "Ok",
                className: "modal_class_success",
            });
        }
        setDownloading(false);
    };

    const handleClear = () => {
        setPrompt(""); setTextRenderingEnabled(false); setTextRendering("");
        setModelType(""); setDuration(""); setAspectRatio(""); setResolution("");
        // I2V
        setI2vImages([]);
        setI2vPreviews([]);

        setStartImage(null); setStartPreview(null); setEndImage(null); setEndPreview(null);
        setAudioFile(null); setAudioName(""); setGeneratedVideo(null);
        [startRef, endRef, audioRef].forEach(r => { if (r.current) r.current.value = ""; });
    };

    const scrollToGenerator = () => {
        generatorRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const scrollToView = () => {
        viewRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const getI2VMaxImages = (model) => {
        if (model === "veo-3.1" || model === "veo-3.1-fast") {
            return 3;
        }
        if (model === "omni-flash") {
            return 2;
        }
        return 1;
    };

    const shouldForceVeoI2VDuration = () => {
        return (
            mode === "Image to Video (I2V)" &&
            (modelType === "veo-3.1" || modelType === "veo-3.1-fast") &&
            i2vImages.length > 1
        );
    };

    const modeObj = MODES.find(m => m.key === mode);
    const isFormValid = prompt.trim() && modelType && duration && aspectRatio && resolution;

    const renderUploadArea = (
        label,
        accept,
        fileState,
        previewState,
        setFile,
        setPreview,
        ref,
        isImage = true
    ) => (
        <div className="mb-3">
            <label className="va-field-label">
                {label} <span className="va-required">*</span>
            </label>

            <div
                className={`va-media-upload ${(isImage ? previewState : fileState) ? "has-file" : ""
                    }`}
                onClick={() => ref.current?.click()}
                onDragOver={handleDragOver}
                onDrop={(e) =>
                    handleDrop(e, setFile, setPreview, isImage)
                }
            >
                <input
                    type="file"
                    ref={ref}
                    accept={accept}
                    onChange={(e) =>
                        handleFileChange(
                            e,
                            setFile,
                            setPreview,
                            isImage
                        )
                    }
                    style={{ display: "none" }}
                />

                {/* ================= IMAGE PREVIEW ================= */}
                {isImage && previewState ? (
                    <div className="va-media-preview">
                        <img
                            src={previewState}
                            alt="Preview"
                            className="va-media-preview-img"
                        />

                        <div className="va-media-preview-overlay">
                            <span className="va-preview-change">
                                Change Image
                            </span>
                        </div>

                        <button
                            type="button"
                            className="va-media-remove"
                            onClick={(e) =>
                                handleRemoveFile(
                                    e,
                                    setFile,
                                    setPreview,
                                    ref
                                )
                            }
                            title="Remove image"
                        >
                            ×
                        </button>

                        <div className="va-media-preview-badge">
                            <span>✓</span>
                            {/* Image Ready */}
                        </div>
                    </div>
                ) : !isImage && fileState ? (
                    /* ================= AUDIO FILE ================= */
                    <div className="va-audio-uploaded">
                        <div className="va-audio-icon">
                            <span>♫</span>
                        </div>

                        <div className="va-audio-details">
                            <div className="va-audio-status">
                                Audio Ready
                            </div>

                            <div className="va-upload-file-name">
                                {audioName}
                            </div>

                            <div className="va-upload-file-size">
                                {(fileState.size / 1024 / 1024).toFixed(2)} MB
                            </div>
                        </div>

                        <button
                            type="button"
                            className="va-media-remove"
                            onClick={(e) => {
                                handleRemoveFile(
                                    e,
                                    setFile,
                                    null,
                                    ref
                                );
                                setAudioName("");
                            }}
                            title="Remove audio"
                        >
                            ×
                        </button>
                    </div>
                ) : (
                    /* ================= EMPTY STATE ================= */
                    <div className="va-upload-empty">
                        <div className="va-upload-orb">
                            <div className="va-upload-orb-inner">
                                {isImage ? (
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.6"
                                        width="25"
                                        height="25"
                                    >
                                        <rect
                                            x="3"
                                            y="3"
                                            width="18"
                                            height="18"
                                            rx="3"
                                        />
                                        <circle
                                            cx="8.5"
                                            cy="8.5"
                                            r="1.5"
                                        />
                                        <path d="m21 15-5-5L5 21" />
                                    </svg>
                                ) : (
                                    <svg
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="1.6"
                                        width="25"
                                        height="25"
                                    >
                                        <path d="M9 18V5l10-2v13" />
                                        <circle
                                            cx="6"
                                            cy="18"
                                            r="3"
                                        />
                                        <circle
                                            cx="16"
                                            cy="16"
                                            r="3"
                                        />
                                    </svg>
                                )}
                            </div>
                        </div>

                        <div className="va-upload-main-text">
                            <span>Drop your {isImage ? "image" : "audio"} here</span>
                            <button
                                type="button"
                                className="va-upload-browse"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    ref.current?.click();
                                }}
                            >
                                Browse
                            </button>
                        </div>

                        <div className="va-upload-subtext">
                            {isImage
                                ? "Upload a reference image for better visual consistency"
                                : "Add background music or audio to your video"}
                        </div>

                        <div className="va-upload-meta">
                            <span>
                                {isImage
                                    ? "JPG"
                                    : "MP3"}
                            </span>
                            <span>
                                {isImage
                                    ? "PNG"
                                    : "WAV"}
                            </span>
                            {isImage && <span>WEBP</span>}
                            <i />
                            <span>
                                {isImage ? "Max 10MB" : "Max 25MB"}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

    const step2LabelText = (mode) => {
        switch (mode) {
            case "Image to Video (I2V)":
                return "Upload Image & Enter Prompt";
            case "Frame Interpolation":
                return "Upload Frames & Enter Prompt";
            case "Audio-Driven (S2V)":
                return "Upload Audio & Enter Prompt";
            default:
                return "Enter Your Prompt";
        }
    }

    const generateRecommendation = async () => {
        setIsRecommandLoading(true);
        try {
            console.log("Generating recommendation for prompt:", prompt);

            const requestBody = {
                prompt: prompt?.trim() || "",
                duration: Number(duration) || 8,
                // referenceImages: startImage ? [startImage] : [],
                referenceImages: i2vImages,
                style: "Ultra-realistic cinematic action",
                resolution: resolution || "1080p",
                aspectRatio: aspectRatio || "16:9",
                audio: audioFile ? audioFile : "NONE",
            };

            console.log("Request body for recommendation:", requestBody);

            const response = await fetch(
                "https://backend.whalesai.com/api/v1/recommendation/get",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            const data = await response.json();

            setRecommendationData(data);

            setIsRecommandLoading(false);

            console.log("Recommendation response:", data);

            if (!response.ok) {
                throw new Error(
                    data?.message || "Failed to generate recommendation"
                );
            }

            if (!data?.success) {
                throw new Error(
                    data?.message || "Recommendation generation failed"
                );
            }

            // Recommendation successfully generated
            console.log("Storyboard:", data.data?.storyboard);
            console.log("Recommendation:", data.data?.recommendation);
            console.log("Selected Settings:", data.data?.selectedSettings);

            return data.data;
        } catch (error) {
            console.error("Error generating recommendation:", error);

            return null;
        }
    };

    return (
        <Fragment>
            {/* <PageHeading
                title="VIDEO AI"
                description="Generate stunning AI-powered videos."
                onInfoClick={() => setShowPdfModal(true)}
                infoTooltip="See sample video"
            /> */}
            <SamplePdfModal pdfModal={showPdfModal} setPdfModal={setShowPdfModal} title="What you can do?">
                <ContentVideoAi />
            </SamplePdfModal>
            {selectedModelInfo && (
                <div
                    className="video-ai-info-modal-overlay"
                    onClick={() => setSelectedModelInfo(null)}
                >
                    <div
                        className="video-ai-info-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="video-ai-info-modal-header">
                            <h5>{selectedModelInfo.label}</h5>

                            <button
                                type="button"
                                className="video-ai-info-close-btn"
                                onClick={() => setSelectedModelInfo(null)}
                            >
                                ✕
                            </button>
                        </div>

                        <div className="video-ai-info-modal-body">
                            <p>{selectedModelInfo.info}</p>
                        </div>
                    </div>
                </div>
            )}

            {selectedModelInfo && (
                <div
                    className="va-info-modal-overlay"
                    onClick={() => setSelectedModelInfo(null)}
                >
                    <div
                        className="va-info-modal"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="va-info-modal-header">
                            <h5>{selectedModelInfo.label}</h5>

                            <button
                                type="button"
                                className="va-info-close-btn"
                                onClick={() => setSelectedModelInfo(null)}
                                aria-label="Close model information"
                            >
                                ✕
                            </button>
                        </div>

                        <div className="va-info-modal-body">
                            <p>{selectedModelInfo.info}
                                <span
                                // style={{ fontSize: '10px' }}
                                >
                                    {selectedModelInfo.allowImg !== 0 ? `Allows up to ${selectedModelInfo.allowImg} ${selectedModelInfo.allowImg === 1 ? 'image.' : 'images.'}` : ''}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            )}

            <div className="va-page">
                <div
                    style={{
                        paddingTop: "20px"
                    }}
                    className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2">
                    <div>
                        {/* <div>
                            <button className="credits-button">CREDITS : {creditToLocalString}</button>
                            <button className="buy-credits-button" onClick={() => navigate("/purchase")}>BUY CREDITS</button>
                            <button onClick={() => navigate("/usage")} className="money-exchange-button">
                                <img src={moneyExchangeIcon} alt="usage" />
                            </button>

                            <button
                                type="button"
                                className="page-heading-info-btn"
                                onClick={() => {
                                    // handleInfoClick();
                                    setShowPdfModal(true);
                                }}
                                title="See sample video"
                            >
                                <InfoIcon />
                            </button>
                        </div> */}
                        <p className="all-page-title all-page-gradient-text text-center my-4">VIDEO AI</p>

                        <div className="credits-actions">
                            

                            <button className="credits-button">
                                CREDITS : {creditToLocalString}
                            </button>

                            <button
                                className="buy-credits-button"
                                onClick={() => navigate("/purchase")}
                            >
                                BUY CREDITS
                            </button>

                            <button
                                onClick={() => navigate("/usage")}
                                className="money-exchange-button"
                            >
                                <img src={moneyExchangeIcon} alt="usage" />
                            </button>

                            <button
                                type="button"
                                className="money-exchange-button"
                                onClick={() => {
                                    setShowPdfModal(true);
                                }}

                            >
                                <img src={sampleIcon} alt="See sample video" />
                            </button>

                        </div>

                        <p style={{ fontSize: "8px" }} className="text-white mt-2 creditText text-center">
                            {totalCredits > 0 ? `${totalCredits} Credits (USD ${creditCostUSD.toFixed(2)} based on Credits Package 3)` : "Select model & duration to see cost"}
                        </p>
                    </div>
                </div>


                {/* HERO */}
                <section className="va-hero">
                    <div className="va-hero-inner">

                        {/* LEFT CONTENT */}
                        <div className="va-hero-copy">

                            <h1 className="va-hero-title">
                                Turn your ideas into{" "}
                                <span className="va-gradient-text">
                                    amazing videos
                                </span>{" "}
                                with VIDEO AI
                            </h1>

                            <p className="va-hero-sub">
                                Create stunning AI-powered videos from text, images, or
                                frames — type it, generate it, share it.
                            </p>

                            <div className="va-hero-actions">
                                <button
                                    className="va-cta-primary"
                                    onClick={scrollToGenerator}
                                >
                                    <AutoAwesomeIcon fontSize="small" />
                                    Start Creating
                                    <ArrowForwardIcon fontSize="small" />
                                </button>

                                <button
                                    className="va-cta-secondary"
                                    onClick={scrollToView}
                                    title="See sample video"
                                >
                                    See a sample
                                </button>
                            </div>
                        </div>

                        {/* RIGHT IMAGE */}
                        <div className="va-hero-visual">
                            <div className="va-hero-glow"></div>

                            <div className="va-hero-image-wrap">
                                <img
                                    src="/videoaiC.png"
                                    alt="AI Video Generator"
                                    className="va-hero-image"
                                />
                            </div>
                        </div>

                    </div>
                </section>

                <div className="va-container">
                    {/* Generator shell */}
                    <div className="va-generator-section" ref={generatorRef}>
                        <div className="va-generator-header">
                            <div>
                                <h2 className="va-generator-title">
                                    Create your video
                                    <span> with VIDEO AI</span>
                                </h2>

                                <p className="va-generator-subtitle">
                                    Choose your generation mode, describe your idea, and let AI
                                    transform it into a stunning video.
                                </p>
                            </div>
                        </div>

                        <div className="va-layout">
                            <div className="va-generator-shell">


                                {/* Step 1 */}
                                <div className="va-step-block">
                                    <div className="va-step-header">
                                        <span className="va-step-badge">1</span>

                                        <div className="va-step-heading-content">
                                            <label className="va-step-title">
                                                Select Video AI Model
                                            </label>
                                        </div>
                                    </div>

                                    <div className="va-model-grid">
                                        {MODELS
                                            .filter(
                                                (m) =>
                                                    !(
                                                        (
                                                            mode === "Image to Video (I2V)" &&
                                                            m.value === "veo-3.1-lite"
                                                        ) ||
                                                        (
                                                            mode === "Frame Interpolation" &&
                                                            m.value === "wan-3.0"
                                                        )
                                                    )
                                            )
                                            .map((m) => {

                                                // const isDisabled = false;
                                                const isDisabled = !isModelAllowed(m.value);

                                                return (
                                                    <div
                                                        key={m.value}
                                                        // className={`va-model-card ${modelType === m.value
                                                        //     ? "selected"
                                                        //     : ""
                                                        //     }`}

                                                        className={`va-model-card
                                                            ${modelType === m.value ? "selected" : ""}
                                                            ${isDisabled ? "va-model-card-disabled" : ""}
                                                        `}

                                                        onClick={() => {
                                                            if (isDisabled) {
                                                                // return;
                                                                swal({
                                                                    title: "Model Disabled",
                                                                    text: "This model is currently disabled.",
                                                                    icon: "warning",
                                                                    button: "OK",
                                                                    className: "modal_class_success",
                                                                });

                                                                return;
                                                            } 

                                                            setModelType(m.value);
                                                            setSelectedModel(m);

                                                            if (mode === "Image to Video (I2V)") {
                                                                const maxImages = getI2VMaxImages(m.value);

                                                                if (i2vImages.length > maxImages) {
                                                                    setI2vImages((prev) => prev.slice(0, maxImages));
                                                                    setI2vPreviews((prev) => prev.slice(0, maxImages));
                                                                }
                                                            }

                                                            const validRes =
                                                                MODEL_RESOLUTIONS[m.value] || [];

                                                            if (
                                                                validRes.length > 0 &&
                                                                (
                                                                    !resolution ||
                                                                    !validRes.includes(resolution)
                                                                )
                                                            ) {
                                                                setResolution(validRes[0]);
                                                            }

                                                            if (m.value === "wan-2.7") {
                                                                setDuration("10");
                                                            } else if (
                                                                m.value === "wan-3.0"
                                                            ) {
                                                                setDuration("30");
                                                            } else if (
                                                                m.value === "seedance"
                                                            ) {
                                                                setDuration("15");
                                                            } else if (
                                                                m.value === "kling"
                                                            ) {
                                                                setDuration("15");
                                                            } else if (
                                                                m.value === "omni-flash"
                                                            ) {
                                                                setDuration("6");
                                                            }

                                                            else if (
                                                                m.value.startsWith("veo")
                                                            ) {
                                                                setDuration("8");
                                                            }
                                                        }}
                                                    >
                                                        <div
                                                            className="va-model-radio"
                                                            aria-hidden="true"
                                                        />
                                                        <div className="va-model-name-row">
                                                            <div>
                                                                <div className="va-model-name">
                                                                    {m.label} <span style={{ fontSize: '10px' }}>
                                                                        {m.allowImg !== 0 ? `(Allows up to ${m.allowImg} ${m.allowImg === 1 ? 'image' : 'images'})` : ''}
                                                                    </span>

                                                                </div>

                                                                <div className="va-model-tag">
                                                                    {m.tag}
                                                                </div>
                                                            </div>

                                                            <button
                                                                type="button"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setSelectedModelInfo(m);
                                                                }}
                                                                aria-label={`More information about ${m.label}`}
                                                                style={{
                                                                    position: "absolute",
                                                                    right: "10px",
                                                                    bottom: "10px",
                                                                    width: "30px",
                                                                    height: "30px",
                                                                    padding: 0,
                                                                    border: "1px solid rgba(255, 255, 255, 0.15)",
                                                                    borderRadius: "50%",
                                                                    background: "rgba(255, 255, 255, 0.06)",
                                                                    color: "#fff",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    cursor: "pointer",
                                                                    zIndex: 5,
                                                                    transition: "all 0.2s ease",
                                                                }}
                                                            >
                                                                <InfoIcon fontSize="small" />
                                                            </button>
                                                        </div>

                                                        <div className="va-model-pricing">
                                                            {(() => {
                                                                const costs = getModelPerSecondCost(
                                                                    m.value,
                                                                    resolution
                                                                );

                                                                return (
                                                                    <div
                                                                        style={{
                                                                            fontSize: "12px",
                                                                            lineHeight: "1.4",
                                                                            color: "#999",
                                                                            marginTop: "8px"
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                color: "#FACC1A",
                                                                            }}
                                                                            className="va-model-price"
                                                                        >
                                                                            Package 1: USD {costs.package1.toFixed(4)} per second
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                color: "#1afaaf",
                                                                            }}
                                                                            className="va-model-price"
                                                                        >
                                                                            Package 2: USD {costs.package2.toFixed(4)} per second
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                color: "#5F77FD",
                                                                            }}
                                                                            className="va-model-price"
                                                                        >
                                                                            Package 3: USD {costs.package3.toFixed(4)} per second
                                                                        </div>

                                                                        <div className="mt-1"
                                                                            style={{
                                                                                fontSize: "10px",
                                                                            }}
                                                                        >
                                                                            <p> {m.timeInfo} </p>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })()}
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>

                                {/* Step 2 */}
                                <div className="va-step-block">
                                    <div className="va-step-header">
                                        <span className="va-step-badge">2</span>

                                        <div className="va-step-heading-content">
                                            <label className="va-step-title">
                                                Choose Generation Mode
                                            </label>
                                        </div>
                                    </div>

                                    <div className="va-mode-grid">
                                        {MODES.map((m) => (
                                            <button
                                                type="button"
                                                key={m.key}
                                                className={`va-mode-card ${mode === m.key ? "selected" : ""
                                                    }`}
                                                onClick={() => {
                                                    setMode(m.key);
                                                    if (m.key !== "Image to Video (I2V)") {
                                                        setI2vImages([]);
                                                        setI2vPreviews([]);
                                                    }
                                                }}
                                                title={m.title}
                                            >
                                                <span className="va-mode-icon">
                                                    {m.icon}
                                                </span>

                                                <span className="va-mode-label">
                                                    {m.label}
                                                </span>
                                            </button>
                                        ))}
                                    </div>

                                    <p className="va-mode-description">
                                        {modeObj?.desc}
                                    </p>
                                </div>


                                {/* Step 3 */}
                                <div className="va-step-block">
                                    <div className="va-step-header">
                                        <span className="va-step-badge">3</span>

                                        <div className="va-step-heading-content">
                                            <label className="va-step-title">
                                                {step2LabelText(mode)}
                                            </label>
                                        </div>
                                    </div>

                                    {mode === "Image to Video (I2V)" && (
                                        <div className="va-upload-section">

                                            <label className="va-field-label">
                                                Upload Image
                                                <span className="va-required"> *</span>

                                                <span style={{ fontSize: '10px' }}>
                                                    {selectedModel && selectedModel.allowImg !== 0 ? ` (Allows up to ${selectedModel.allowImg} ${selectedModel.allowImg === 1 ? 'image' : 'images'})` : ''}
                                                </span>

                                            </label>

                                            <div className="va-i2v-upload-wrapper">

                                                <input
                                                    type="file"
                                                    id="i2v-image-upload"
                                                    accept="image/jpeg,image/png,image/webp"
                                                    multiple
                                                    onChange={handleI2VImagesChange}
                                                    style={{ display: "none" }}
                                                />

                                                {/* ================= IMAGE PREVIEWS ================= */}
                                                {i2vPreviews.length > 0 ? (
                                                    <div className="va-i2v-images-container">

                                                        <div className="va-i2v-image-grid">

                                                            {i2vPreviews.map((preview, index) => (
                                                                <div
                                                                    className="va-i2v-image-card"
                                                                    key={`${preview}-${index}`}
                                                                >
                                                                    <img
                                                                        src={preview}
                                                                        alt={`Reference ${index + 1}`}
                                                                        className="va-i2v-preview-img"
                                                                    />

                                                                    <div className="va-i2v-image-number">
                                                                        {index + 1}
                                                                    </div>

                                                                    <button
                                                                        type="button"
                                                                        className="va-i2v-remove-btn"
                                                                        onClick={(e) =>
                                                                            handleRemoveI2VImage(index, e)
                                                                        }
                                                                        title="Remove image"
                                                                    >
                                                                        ×
                                                                    </button>

                                                                    <div className="va-i2v-image-ready">
                                                                        <span>✓</span>
                                                                        {/* Image Ready */}
                                                                    </div>
                                                                </div>
                                                            ))}

                                                            {/* ADD MORE */}
                                                            {i2vImages.length <
                                                                getI2VMaxImages(modelType) && (
                                                                    <label
                                                                        htmlFor="i2v-image-upload"
                                                                        className="va-i2v-add-card"
                                                                    >
                                                                        <div className="va-upload-orb">
                                                                            <div className="va-upload-orb-inner">

                                                                                <svg
                                                                                    viewBox="0 0 24 24"
                                                                                    fill="none"
                                                                                    stroke="currentColor"
                                                                                    strokeWidth="1.6"
                                                                                    width="25"
                                                                                    height="25"
                                                                                >
                                                                                    <rect
                                                                                        x="3"
                                                                                        y="3"
                                                                                        width="18"
                                                                                        height="18"
                                                                                        rx="3"
                                                                                    />
                                                                                    <circle
                                                                                        cx="8.5"
                                                                                        cy="8.5"
                                                                                        r="1.5"
                                                                                    />
                                                                                    <path d="m21 15-5-5L5 21" />
                                                                                </svg>

                                                                            </div>
                                                                        </div>

                                                                        <div className="va-upload-main-text">
                                                                            <span>Add another image</span>
                                                                        </div>

                                                                        <div className="va-upload-subtext">
                                                                            Add another reference image
                                                                        </div>

                                                                        <div className="va-upload-meta">
                                                                            <span>JPG</span>
                                                                            <span>PNG</span>
                                                                            <span>WEBP</span>
                                                                            <i />
                                                                            <span>Max 10MB</span>
                                                                        </div>
                                                                    </label>
                                                                )}

                                                        </div>

                                                        {/* IMAGE COUNT */}
                                                        <div className="va-i2v-upload-info">
                                                            <span>
                                                                {i2vImages.length}/
                                                                {getI2VMaxImages(modelType)} images
                                                            </span>

                                                            <span>
                                                                {modelType === "veo-3.1" ||
                                                                    modelType === "veo-3.1-fast"
                                                                    ? "Up to 3 images"
                                                                    : modelType === "omni-flash"
                                                                        ? "Up to 2 images"
                                                                        : "Single image only"}
                                                            </span>
                                                        </div>

                                                    </div>
                                                ) : (

                                                    /* ================= EMPTY UPLOAD STATE ================= */
                                                    <label
                                                        htmlFor="i2v-image-upload"
                                                        className="va-media-upload va-i2v-empty-upload"
                                                    >

                                                        <div className="va-upload-empty">

                                                            <div className="va-upload-orb">
                                                                <div className="va-upload-orb-inner">

                                                                    <svg
                                                                        viewBox="0 0 24 24"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        strokeWidth="1.6"
                                                                        width="25"
                                                                        height="25"
                                                                    >
                                                                        <rect
                                                                            x="3"
                                                                            y="3"
                                                                            width="18"
                                                                            height="18"
                                                                            rx="3"
                                                                        />

                                                                        <circle
                                                                            cx="8.5"
                                                                            cy="8.5"
                                                                            r="1.5"
                                                                        />

                                                                        <path d="m21 15-5-5L5 21" />
                                                                    </svg>

                                                                </div>
                                                            </div>

                                                            <div className="va-upload-main-text">
                                                                <span>Drop your image here</span>

                                                                <button
                                                                    type="button"
                                                                    className="va-upload-browse"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();

                                                                        document
                                                                            .getElementById("i2v-image-upload")
                                                                            ?.click();
                                                                    }}
                                                                >
                                                                    Browse
                                                                </button>
                                                            </div>

                                                            <div className="va-upload-subtext">
                                                                Upload reference images for better visual
                                                                consistency
                                                            </div>

                                                            <div className="va-upload-meta">
                                                                <span>JPG</span>
                                                                <span>PNG</span>
                                                                <span>WEBP</span>
                                                                <i />
                                                                <span>Max 10MB</span>
                                                            </div>

                                                        </div>

                                                    </label>
                                                )}

                                            </div>
                                        </div>
                                    )}

                                    {/* hello Image */}

                                    {mode === "Frame Interpolation" && (
                                        <div className="va-upload-row">
                                            <div>
                                                {renderUploadArea(
                                                    "Start Frame",
                                                    "image/jpeg,image/png,image/webp",
                                                    startImage,
                                                    startPreview,
                                                    setStartImage,
                                                    setStartPreview,
                                                    startRef
                                                )}
                                            </div>

                                            <div>
                                                {renderUploadArea(
                                                    "End Frame",
                                                    "image/jpeg,image/png,image/webp",
                                                    endImage,
                                                    endPreview,
                                                    setEndImage,
                                                    setEndPreview,
                                                    endRef
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {mode === "Audio-Driven (S2V)" && (
                                        <div className="va-upload-section">
                                            {renderUploadArea(
                                                "Upload Audio",
                                                "audio/mpeg,audio/wav",
                                                audioFile,
                                                null,
                                                setAudioFile,
                                                null,
                                                audioRef,
                                                false
                                            )}
                                        </div>
                                    )}
                                    <div className="va-prompt-section">
                                        {/* <label className="va-field-label">
                                            Enter Prompt <span className="va-required"> *</span>
                                        </label> */}

                                        <div className="d-flex justify-content-between align-items-center mt-2 " >
                                            <label className="va-field-label">
                                                Enter Prompt <span className="va-required"> *</span>
                                            </label>
                                            <button
                                                type="button"
                                                className="va-clear-btn"
                                                onClick={handleClear}
                                                disabled={isLoading}
                                            >
                                                Clear
                                            </button>
                                        </div>

                                        <div className="va-prompt-wrap">
                                            <textarea
                                                className="va-prompt-textarea"
                                                value={prompt}
                                                maxLength={2000}
                                                onChange={(e) => setPrompt(e.target.value)}
                                                placeholder="Describe the scene, motion, camera movement, lighting, and visual style you want to generate"
                                            />

                                            <span className="va-prompt-count">
                                                {prompt.length}/2000
                                            </span>
                                        </div>
                                        {
                                            promptSuggestion ?
                                                <div className="va-suggested-row">
                                                    <span className="">
                                                        <span className="va-suggested-label text-warning ">  Suggested Prompt: </span>
                                                        <span
                                                            className="va-suggested-prompt"
                                                            onClick={() => setPrompt(promptSuggestion)}
                                                        >{promptSuggestion}</span>
                                                    </span>
                                                </div>
                                                :
                                                <div className="va-suggested-row">
                                                    <span className="">
                                                        <span className="va-suggested-label text-warning ">What you can enter: </span>
                                                        <span
                                                            className="va-suggested-prompt"
                                                            onClick={() => setPrompt(suggestedPrompt)}
                                                        >{suggestedPrompt}</span>
                                                    </span>
                                                </div>
                                        }
                                    </div>

                                </div>




                                {/* Step 4 */}
                                <div className="va-step-block">
                                    <div className="va-step-header">
                                        <span className="va-step-badge">4</span>

                                        <div className="va-step-heading-content">
                                            <label className="va-step-title">
                                                Configure Video Settings
                                            </label>
                                        </div>
                                    </div>

                                    <div className="va-settings-grid">

                                        {/* Duration */}
                                        <div className="va-settings-card">
                                            <label className="va-field-label">
                                                Duration (Seconds)
                                                <span className="va-required"> *</span>
                                            </label>

                                            <div className="va-slider-wrap">
                                                {!modelType ? (
                                                    <div
                                                        style={{
                                                            textWrap: "nowrap",
                                                            paddingTop: "0px"
                                                        }}
                                                        className="va-empty-hint">
                                                        Select an AI Model first.
                                                    </div>
                                                ) : (
                                                    <Slider
                                                        value={
                                                            Number(duration) ||
                                                            (modelType.startsWith("veo")
                                                                ? 4
                                                                : 5)
                                                        }
                                                        // onChange={(e, val) =>
                                                        //     setDuration(String(val))
                                                        // }
                                                        onChange={(e, val) => {
                                                            if (shouldForceVeoI2VDuration()) {
                                                                setDuration("8");
                                                                return;
                                                            }
                                                            setDuration(String(val));
                                                        }}
                                                        step={
                                                            modelType.startsWith("veo")
                                                                ? null
                                                                : 1
                                                        }
                                                        marks={
                                                            modelType.startsWith("veo")
                                                                ? [
                                                                    {
                                                                        value: 4,
                                                                        label: "4s"
                                                                    },
                                                                    {
                                                                        value: 6,
                                                                        label: "6s"
                                                                    },
                                                                    {
                                                                        value: 8,
                                                                        label: "8s"
                                                                    }
                                                                ]
                                                                : [
                                                                    {
                                                                        value:
                                                                            modelType.startsWith(
                                                                                "wan"
                                                                            )
                                                                                ? 2
                                                                                : modelType ===
                                                                                    "seedance"
                                                                                    ? 4
                                                                                    : 3,
                                                                        label: `${modelType.startsWith(
                                                                            "wan"
                                                                        )
                                                                            ? 2
                                                                            : modelType ===
                                                                                "seedance"
                                                                                ? 4
                                                                                : 3
                                                                            }s`
                                                                    },
                                                                    {
                                                                        value: 10,
                                                                        label: "10s"
                                                                    },
                                                                    ...(modelType === "wan-3.0" || modelType === "seedance"
                                                                        ? [
                                                                            {
                                                                                value: 20,
                                                                                label: "20s"
                                                                            },
                                                                            {
                                                                                value: 30,
                                                                                label: "30s"
                                                                            }
                                                                        ]
                                                                        : modelType !==
                                                                            "wan-2.7"
                                                                            ? [
                                                                                {
                                                                                    value: 15,
                                                                                    label: "15s"
                                                                                }
                                                                            ]
                                                                            : [])
                                                                ]
                                                        }
                                                        min={
                                                            modelType.startsWith("veo")
                                                                ? 4
                                                                : modelType.startsWith("wan")
                                                                    ? 2
                                                                    : modelType === "seedance"
                                                                        ? 4 : modelType === "omni-flash" ? 10
                                                                            : 3
                                                        }
                                                        max={
                                                            modelType.startsWith("veo")
                                                                ? 8
                                                                : modelType === "wan-2.7"
                                                                    ? 10 : modelType === "omni-flash" ? 10
                                                                        : modelType === "wan-3.0" || modelType === "seedance"
                                                                            ? 30
                                                                            : 15
                                                        }
                                                        valueLabelDisplay="auto"
                                                        className="va-mui-slider"
                                                    />
                                                )}
                                            </div>


                                            {modelType &&
                                                (modelType === "veo-3.1" || modelType === "veo-3.1-fast") &&
                                                mode === "Image to Video (I2V)" &&
                                                i2vImages.length > 1 && (
                                                    <div className="va-duration-info">
                                                        <span className="va-duration-info-text">
                                                            <strong>
                                                                {MODELS.find((m) => m.value === modelType)?.label || modelType}
                                                            </strong>{" "}
                                                            supports a fixed <strong>8 s</strong> duration when using multiple images.
                                                        </span>
                                                    </div>
                                                )}

                                        </div>

                                        {/* Resolution */}
                                        <div className="va-settings-card">
                                            <label className="va-field-label">
                                                Resolution
                                                <span className="va-required"> *</span>
                                            </label>

                                            <div className="va-chip-grid">
                                                {!modelType ? (
                                                    <div
                                                        style={{
                                                            textWrap: "nowrap",
                                                            paddingTop: "12px"
                                                        }}
                                                        className="va-empty-hint">
                                                        Select an AI Model first.
                                                    </div>
                                                ) : (
                                                    RESOLUTIONS
                                                        .filter((r) =>
                                                            (
                                                                MODEL_RESOLUTIONS[modelType] || []
                                                            ).includes(r.value)
                                                        )
                                                        .map((r) => (
                                                            <button
                                                                type="button"
                                                                key={r.value}
                                                                className={`va-chip ${resolution === r.value
                                                                    ? "selected"
                                                                    : ""
                                                                    }`}
                                                                onClick={() =>
                                                                    setResolution(r.value)
                                                                }
                                                            >
                                                                <div className="va-chip-icon">
                                                                    {r.icon}
                                                                </div>

                                                                <div className="va-chip-label">
                                                                    {r.label}
                                                                </div>
                                                            </button>
                                                        ))
                                                )}
                                            </div>
                                        </div>
                                        {/* Aspect Ratio */}
                                        <div className="va-settings-card">
                                            <label className="va-field-label">
                                                Aspect Ratio
                                                <span className="va-required"> *</span>
                                            </label>

                                            <div className="va-chip-grid">
                                                {ASPECTS.map((a) => (
                                                    <button
                                                        type="button"
                                                        key={a.value}
                                                        style={{
                                                            background: aspectRatio === a.value
                                                                ? "linear-gradient(135deg, #4F46E5 0%, #7C3AED 50%, #C026D3 100%)"
                                                                : a.value === "16:9"
                                                                    ? "linear-gradient(135deg, rgba(79, 70, 229, 0.18) 0%, rgba(124, 58, 237, 0.12) 100%)"
                                                                    : "linear-gradient(135deg, rgba(192, 38, 211, 0.16) 0%, rgba(236, 72, 153, 0.11) 100%)",

                                                            borderColor: aspectRatio === a.value
                                                                ? "rgba(196, 181, 253, 0.65)"
                                                                : a.value === "16:9"
                                                                    ? "rgba(99, 102, 241, 0.25)"
                                                                    : "rgba(236, 72, 153, 0.22)",

                                                            boxShadow: aspectRatio === a.value
                                                                ? "0 8px 24px rgba(124, 58, 237, 0.30)"
                                                                : "none",

                                                            color: aspectRatio === a.value
                                                                ? "#ffffff"
                                                                : undefined,
                                                        }}
                                                        className={`va-chip ${aspectRatio === a.value
                                                            ? "selected"
                                                            : ""
                                                            }`}
                                                        onClick={() =>
                                                            setAspectRatio(a.value)
                                                        }
                                                    >
                                                        <div className="va-chip-value">
                                                            {a.value}
                                                        </div>
                                                        <div className="va-chip-label">
                                                            {a.label}
                                                        </div>
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Recommendation Button */}
                                        <div className="va-settings-card">
                                            <button
                                                type="button"
                                                className={`va-generate-btn ${isRecommandLoading ? "va-progress-rec" : ""}`}
                                                disabled={isRecommandLoading || !prompt}
                                                onClick={() => {
                                                    generateRecommendation();
                                                }}
                                            >
                                                <AutoAwesomeIcon fontSize="small" />
                                                {/* Recommendation */}
                                                {isRecommandLoading ? "Checking for Recommendations" : "Recommendation"}
                                            </button>
                                        </div>
                                    </div>


                                    {isRecommandLoading && (
                                        <div className="va-progress-card">
                                            <div className="va-progress-orb">
                                                <AutoAwesomeIcon />
                                            </div>

                                            <p className="va-progress-title">
                                                AI is creating your recommendation
                                            </p>

                                            <p className="va-progress-text">
                                                AI is analyzing your video idea, planning the scenes,
                                                and selecting the most suitable video model for your
                                                production.
                                            </p>

                                            <div className="va-ai-facts">
                                                <AiFilmmakingInsightsDisplay />
                                            </div>
                                        </div>
                                    )}
                                    {/* Recommendation Result */}
                                    {!isRecommandLoading && recommendationData?.success && recommendationData?.data && (
                                        <div className="va-recommendation-result">

                                            <div className="va-recommendation-header">
                                                <div className="va-recommendation-title-wrap">
                                                    <div className="va-recommendation-icon">
                                                        <AutoAwesomeIcon fontSize="small" />
                                                    </div>

                                                    <div>
                                                        <h3>Video AI Recommendation</h3>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Storyboard */}
                                            {recommendationData.data.storyboard?.imageUrl && (
                                                <div className="va-recommendation-section">

                                                    {/* Section Header */}
                                                    <div className="va-recommendation-section-title">
                                                        <div className="va-section-icon storyboard">
                                                            <MovieIcon fontSize="small" />
                                                        </div>

                                                        <div>
                                                            <h4>Storyboard</h4>
                                                        </div>
                                                    </div>

                                                    {/* Storyboard Image */}
                                                    <div className="va-storyboard-preview">

                                                        {/* Toolbar */}
                                                        <div className="va-storyboard-toolbar">

                                                            <div className="va-storyboard-toolbar-left">
                                                                <span>
                                                                    {Math.round(storyboardZoom * 100)}%
                                                                </span>
                                                            </div>

                                                            <div className="va-storyboard-toolbar-actions">

                                                                <button
                                                                    type="button"
                                                                    className="va-storyboard-tool-btn"
                                                                    onClick={handleStoryboardZoomOut}
                                                                    disabled={storyboardZoom <= 0.6}
                                                                    title="Zoom out"
                                                                >
                                                                    <ZoomOutIcon fontSize="small" />
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="va-storyboard-tool-btn"
                                                                    onClick={handleStoryboardZoomReset}
                                                                    title="Reset zoom"
                                                                >
                                                                    <RestartAltIcon fontSize="small" />
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="va-storyboard-tool-btn"
                                                                    onClick={handleStoryboardZoomIn}
                                                                    disabled={storyboardZoom >= 3}
                                                                    title="Zoom in"
                                                                >
                                                                    <ZoomInIcon fontSize="small" />
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="va-storyboard-tool-btn download"
                                                                    onClick={handleStoryboardDownload}
                                                                    title="Download storyboard"
                                                                >
                                                                    <DownloadIcon fontSize="small" />
                                                                </button>

                                                            </div>
                                                        </div>

                                                        {/* Image Area */}
                                                        <div className="va-storyboard-image-wrapper">
                                                            <img
                                                                src={
                                                                    recommendationData.data.storyboard.imageUrl
                                                                }
                                                                alt={
                                                                    recommendationData.data.storyboard.title ||
                                                                    "AI Generated Storyboard"
                                                                }
                                                                className="va-storyboard-image"
                                                                style={{
                                                                    transform: `scale(${storyboardZoom})`,
                                                                }}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                            )}

                                            {recommendationData.data.recommendation && (
                                                <div className="va-recommendation-section">

                                                    <div className="va-recommendation-section-title">
                                                        <div className="va-section-icon model">
                                                            <SmartToyIcon fontSize="small" />
                                                        </div>
                                                        <div>
                                                            <h4>Recommended AI Model</h4>
                                                        </div>
                                                    </div>


                                                    <div className="va-model-recommendation">
                                                        <div className="va-recommended-model">

                                                            <div className="va-model-badge">
                                                                <AutoAwesomeIcon fontSize="small" />
                                                                Recommended
                                                            </div>

                                                            <h2>
                                                                {
                                                                    recommendationData.data
                                                                        .recommendation
                                                                        .recommendedModel
                                                                }
                                                            </h2>

                                                            <div className="va-confidence">

                                                                <div className="va-confidence-label">
                                                                    <span>Confidence</span>

                                                                    <strong>
                                                                        {
                                                                            recommendationData.data
                                                                                .recommendation
                                                                                .confidence
                                                                        }%
                                                                    </strong>
                                                                </div>

                                                                <div className="va-confidence-bar">
                                                                    <div
                                                                        style={{
                                                                            width: `${Math.min(
                                                                                Math.max(
                                                                                    Number(
                                                                                        recommendationData.data
                                                                                            .recommendation
                                                                                            .confidence
                                                                                    ) || 0,
                                                                                    0
                                                                                ),
                                                                                100
                                                                            )}%`
                                                                        }}
                                                                    />
                                                                </div>

                                                            </div>

                                                        </div>
                                                        <div className="va-model-reasons">

                                                            <div className="va-detail-label">
                                                                <CheckCircleIcon fontSize="small" />
                                                                Why this model?
                                                            </div>

                                                            <div className="va-reasons-list">

                                                                {recommendationData.data.recommendation.reasons?.map(
                                                                    (reason, index) => (
                                                                        <div
                                                                            className="va-reason-item"
                                                                            key={index}
                                                                        >
                                                                            <CheckCircleIcon fontSize="small" />
                                                                            <span>{reason}</span>
                                                                        </div>
                                                                    )
                                                                )}

                                                            </div>

                                                        </div>
                                                        {/* <div className="va-model-extra">

                                                            <div className="va-alternative-model">

                                                                <span className="va-extra-label">
                                                                    Alternative Model
                                                                </span>

                                                                <strong>
                                                                    {
                                                                        recommendationData.data
                                                                            .recommendation
                                                                            .alternativeModel
                                                                    }
                                                                </strong>

                                                            </div>


                                                            <div className="va-expected-result">

                                                                <span className="va-extra-label">
                                                                    Expected Result
                                                                </span>

                                                                <p>
                                                                    {
                                                                        recommendationData.data
                                                                            .recommendation
                                                                            .expectedResult
                                                                    }
                                                                </p>

                                                            </div>

                                                        </div> */}

                                                    </div>

                                                </div>
                                            )}

                                            {recommendationData.data.selectedSettings && (
                                                <div className="va-recommendation-section">

                                                    <div className="va-recommendation-section-title">
                                                        <div className="va-section-icon settings">
                                                            <TuneIcon fontSize="small" />
                                                        </div>
                                                        <div>
                                                            <h4>Selected Settings</h4>
                                                        </div>
                                                    </div>
                                                    <div className="va-selected-settings">
                                                        <div className="va-selected-setting">
                                                            <span>Duration</span>
                                                            <strong>
                                                                {
                                                                    recommendationData.data
                                                                        .selectedSettings.duration
                                                                }s
                                                            </strong>
                                                        </div>

                                                        <div className="va-selected-setting">
                                                            <span>Resolution</span>
                                                            <strong>
                                                                {
                                                                    recommendationData.data
                                                                        .selectedSettings.resolution
                                                                }
                                                            </strong>
                                                        </div>
                                                        <div className="va-selected-setting">
                                                            <span>Aspect Ratio</span>
                                                            <strong>
                                                                {
                                                                    recommendationData.data
                                                                        .selectedSettings.aspectRatio
                                                                }
                                                            </strong>
                                                        </div>

                                                        <div className="va-selected-setting">
                                                            <span>Audio</span>
                                                            <strong>
                                                                {
                                                                    recommendationData.data
                                                                        .selectedSettings.audio
                                                                }
                                                            </strong>
                                                        </div>

                                                    </div>

                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                {/* Cost */}
                                <div className="va-cost-bar">
                                    <div className="va-cost-info">
                                        <span className="va-cost-label">
                                            Estimated Generation Cost
                                        </span>
                                        <span
                                            style={{
                                                fontSize: "1.2rem",
                                                fontWeight: 600,
                                                color: "#fff",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "4px"
                                            }}
                                            className="va-cost-value">
                                            {totalCredits > 0 ? totalCredits : "—"}
                                            <span>credits</span>
                                        </span>
                                        <span className="va-cost-usd">
                                            {totalCredits < 0
                                                ? `Select model & duration to see cost`
                                                : <div>
                                                    <p
                                                        style={{
                                                            lineHeight: 1.5,
                                                            opacity: 0.7,
                                                            marginBottom: "0px",
                                                            color: "#FACC1A",
                                                        }}
                                                    >Package 1: USD ${creditCostUSD1.toFixed(2)} </p>
                                                    <p
                                                        style={{
                                                            lineHeight: 1.5,
                                                            opacity: 0.7,
                                                            marginBottom: "0px",
                                                            color: "#1afaaf",
                                                        }}
                                                    >Package 2: USD ${creditCostUSD2.toFixed(2)} </p>
                                                    <p
                                                        style={{
                                                            lineHeight: 1.5,
                                                            opacity: 0.7,
                                                            marginBottom: "0px",
                                                            color: "#5F77FD",
                                                        }}
                                                    >Package 3: USD ${creditCostUSD.toFixed(2)} </p>
                                                </div>}
                                        </span>
                                    </div>

                                    <div className="va-cost-actions">
                                        <button
                                            type="button"
                                            className="va-clear-btn"
                                            onClick={handleClear}
                                            disabled={isLoading}
                                        >
                                            Clear
                                        </button>
                                        <button
                                            type="button"
                                            className="va-generate-btn"
                                            onClick={handleGenerate}
                                            disabled={!isFormValid || isLoading}
                                        >
                                            <AutoAwesomeIcon fontSize="small" />

                                            {isLoading
                                                ? "Processing..."
                                                : "Generate Video"}
                                        </button>
                                    </div>
                                </div>

                                <p className="va-disclaimer">
                                    AI-generated content may occasionally contain mistakes.
                                    Please verify important information.
                                </p>

                                {!isLoading && generatedVideo && (
                                    <div className="va-result-card">
                                        <div className="va-result-badge">
                                            <span />
                                            Generation Complete
                                        </div>

                                        <h4 className="va-result-title">
                                            Your video is ready
                                        </h4>

                                        <div className="va-result-player">
                                            <video
                                                src={
                                                    typeof generatedVideo === "string"
                                                        ? generatedVideo
                                                        : generatedVideo.videoUrl
                                                }
                                                controls
                                                autoPlay
                                                muted
                                            />
                                        </div>

                                        <div className="va-result-info-grid">
                                            <div className="va-result-info-item">
                                                <span className="va-result-info-label">
                                                    Generation Model
                                                </span>
                                                <strong>
                                                    {generatedVideo?.data?.mode || "—"}
                                                </strong>
                                            </div>

                                            <div className="va-result-info-item">
                                                <span className="va-result-info-label">
                                                    AI Model
                                                </span>
                                                <strong>
                                                    {/* {modelType || "—"} */}
                                                    {MODELS.find((model) => model.value === generatedVideo?.data?.model)?.label || "—"}
                                                </strong>
                                            </div>

                                            <div className="va-result-info-item">
                                                <span className="va-result-info-label">
                                                    Duration
                                                </span>
                                                <strong>
                                                    {generatedVideo?.data?.duration ? `${generatedVideo?.data?.duration}s` : "—"}
                                                </strong>
                                            </div>

                                            <div className="va-result-info-item">
                                                <span className="va-result-info-label">
                                                    Resolution
                                                </span>
                                                <strong>
                                                    {generatedVideo?.data?.resolution || "—"}
                                                </strong>
                                            </div>

                                            <div className="va-result-info-item">
                                                <span className="va-result-info-label">
                                                    Aspect Ratio
                                                </span>
                                                <strong>
                                                    {generatedVideo?.data?.aspectRatio || "—"}
                                                </strong>
                                            </div>
                                        </div>

                                        {/* ========================= DOWNLOAD BUTTON========================== */}
                                        <Button
                                            className="va-download-btn"
                                            variant="contained"
                                            onClick={downloadVideo}
                                            disabled={downloading}
                                            startIcon={<DownloadOutlined />}
                                        >
                                            {downloading
                                                ? "Downloading..."
                                                : "Download Video"}
                                        </Button>

                                        {/* TODO =========================FREE RESOLUTION 2K 4K ========================== */}
                                        {/* {resolution !== "4K" && (
                                            <div className="va-conversion-section">
                                                <div className="va-conversion-grid">
                                                    {resolution !== "2K" && (
                                                        <button
                                                            type="button"
                                                            className="va-conversion-btn"
                                                            onClick={() => handleConvertResolution("2K")}
                                                        >
                                                            <span className="va-conversion-btn-title">
                                                                Convert 2K
                                                            </span>
                                                        </button>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className="va-conversion-btn"
                                                        onClick={() => handleConvertResolution("4K")}
                                                    >
                                                        <span className="va-conversion-btn-title">
                                                            Convert 4K
                                                        </span>
                                                    </button>

                                                </div>
                                            </div>
                                        )} */}
                                    </div>
                                )}


                                {/* Progress */}
                                {isLoading && (
                                    <div className="va-progress-card">
                                        <div className="va-progress-orb">
                                            <AutoAwesomeIcon />
                                        </div>

                                        <p className="va-progress-title">
                                            AI is creating your video
                                        </p>

                                        <p className="va-progress-text">
                                            Your video is being generated in the background.
                                            You can safely return later. Once ready, it will
                                            also be available from your Usage page.
                                        </p>

                                        <div className="va-ai-facts">
                                            <AiFactsDisplay />
                                        </div>

                                    </div>
                                )}

                            </div>


                            {/* =========================SIDEBAR ========================= */}
                            <aside className="va-sidebar">
                                <div className="va-credit-panel">

                                    <div className="va-credit-heading">
                                        <BoltIcon fontSize="small" />
                                        <span>Your Credits</span>
                                    </div>

                                    <div className="va-credit-amount">
                                        {creditToLocalString}
                                        <span>Credits</span>
                                    </div>

                                    <button
                                        type="button"
                                        className="va-buy-credits-btn"
                                        onClick={() => navigate("/purchase")}
                                    >
                                        Buy Credits
                                    </button>

                                    <button
                                        type="button"
                                        className="va-usage-link"
                                        onClick={() => navigate("/usage")}
                                    >
                                        <img
                                            src={moneyExchangeIcon}
                                            alt=""
                                        />
                                        View Usage
                                    </button>
                                </div>
                                <div
                                    className="va-sidebar-tip"
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "12px",
                                        width: "100%",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <div
                                        className="va-sidebar-tip-icon"
                                        style={{
                                            flexShrink: 0,
                                            width: "32px",
                                            height: "32px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <AutoAwesomeIcon fontSize="small" />
                                    </div>

                                    <div
                                        style={{
                                            flex: 1,
                                            minWidth: 0,
                                        }}
                                    >
                                        <strong
                                            className="va-gradient-text"
                                            style={{
                                                display: "block",
                                                marginBottom: "5px",
                                            }}
                                        >
                                            Pro Tip
                                        </strong>

                                        <p
                                            style={{
                                                margin: 0,
                                                lineHeight: 1.5,
                                            }}
                                        >
                                            {currentTip.tip}
                                        </p>

                                        <p
                                            style={{
                                                margin: "6px 0 0",
                                                fontSize: "11px",
                                                lineHeight: 1.45,
                                                opacity: 0.7,
                                            }}
                                        >
                                            {currentTip.reason}
                                        </p>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-between align-items-center mt-2 " >
                                    <p></p>
                                    <button
                                        type="button"
                                        className="va-clear-btn"
                                        onClick={handleClear}
                                        disabled={isLoading}
                                    >
                                        Clear All
                                    </button>
                                </div>
                            </aside>

                        </div>
                    </div>
                    {/* AI Video Examples */}
                    <section className="va-examples" ref={viewRef}>
                        {/* SECTION HEADER */}
                        <div className="va-section-heading">
                            <div>
                                <h2 className="va-examples-title">
                                    See What <span>You Can Create</span>
                                </h2>

                                <p className="va-examples-sub">
                                    From imagination to reality — powered by VIDEO AI
                                </p>
                            </div>
                        </div>


                        {/* VIDEO SHOWCASE */}
                        <div className="va-examples-grid">
                            {VIDEO_SHOWCASE_DATA.map((video, index) => (
                                <div className="va-example-card" key={video.id}>
                                    <div className="va-video-wrapper">
                                        <video
                                            ref={(el) => {
                                                videoRefs.current[index] = el;
                                            }}
                                            src={video.videoUrl}
                                            poster={video.poster}
                                            controls
                                            muted
                                            loop
                                            playsInline
                                            preload="metadata"
                                            className="va-example-video"
                                            onPlay={() => {
                                                videoRefs.current.forEach((currentVideo, videoIndex) => {
                                                    if (currentVideo && videoIndex !== index) {
                                                        currentVideo.pause();
                                                    }
                                                });
                                            }}
                                        />
                                    </div>

                                    <div className="va-example-info">
                                        <h3>{video.title}</h3>
                                        <p>{video.type}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* FEATURES SECTION */}
                        <div className="va-features">

                            {/* FEATURE 1 */}
                            <div className="va-feature-item">
                                <div className="va-feature-icon va-feature-icon-purple">
                                    <RocketLaunchIcon />
                                </div>
                                <h3>Super Easy</h3>
                                <p>
                                    No steep learning curve
                                </p>
                            </div>
                            {/* FEATURE 2 */}
                            <div className="va-feature-item">
                                <div className="va-feature-icon va-feature-icon-cyan">
                                    <BoltIcon />
                                </div>
                                <h3>Powerful AI Models</h3>
                                <p>
                                    Best models in one place
                                </p>
                            </div>
                            {/* FEATURE 3 */}
                            <div className="va-feature-item">
                                <div className="va-feature-icon va-feature-icon-pink">
                                    <FavoriteIcon />
                                </div>

                                <h3>Made for Creators</h3>

                                <p>
                                    From ideas to viral content
                                </p>
                            </div>
                            {/* FEATURE 4 */}
                            <div className="va-feature-item">
                                <div className="va-feature-icon va-feature-icon-yellow">
                                    <StarIcon />
                                </div>

                                <h3>Affordable</h3>

                                <p>
                                    Create more, spend less
                                </p>
                            </div>
                        </div>

                    </section>
                </div>
            </div>
        </Fragment>
    );
}